import { adminRequest, authServiceRequest } from './baseAPI';

// Admin Settings API
export const adminSettingsAPI = {
  // Get current web version and all settings
  getWebVersion: async () => {
    // Web Version Management is only available on auth service for now
    // Skip primary endpoints and go directly to auth service
    try {
      console.log('Using auth service for web version settings (primary not implemented)');
      const response = await authServiceRequest('/settings/web-version');
      return response;
    } catch (error) {
      console.error('Failed to get web version from auth service:', error);
      throw error;
    }
  },

  // Update web version configuration
  updateWebVersion: async (settings) => {
    // Web Version Management is only available on auth service for now
    try {
      console.log('Using auth service for web version update (primary not implemented)');
      const response = await authServiceRequest('/settings/web-version', {
        method: 'PUT',
        data: settings
      });
      return response;
    } catch (error) {
      console.error('Failed to update web version on auth service:', error);
      throw error;
    }
  },

  // Get all system settings
  getAllSettings: async () => {
    try {
      const response = await authServiceRequest('/settings');
      return response;
    } catch (error) {
      console.error('Failed to get all settings:', error);
      throw error;
    }
  },

  // Update Web3 configuration specifically
  updateWeb3Config: async (config) => {
    try {
      const response = await authServiceRequest('/settings/web3-config', {
        method: 'PUT',
        data: config
      });
      return response;
    } catch (error) {
      console.error('Failed to update Web3 config:', error);
      throw error;
    }
  },

  // Get available authentication methods (public endpoint)
  getAuthMethods: async () => {
    try {
      const response = await authServiceRequest('/auth/auth-method');
      return response;
    } catch (error) {
      console.error('Failed to get auth methods:', error);
      throw error;
    }
  },

  // ============ MAINTENANCE MODE ENDPOINTS ============
  // Note: Maintenance mode is controlled from the Auth Service, not the main service

  // Get current maintenance mode status
  getMaintenanceStatus: async () => {
    try {
      // Using auth service directly - maintenance mode is managed from auth service
      const response = await authServiceRequest('/settings/maintenance');
      return response;
    } catch (error) {
      console.error('Failed to get maintenance status:', error);
      throw error;
    }
  },

  // Toggle maintenance mode on/off
  toggleMaintenanceMode: async (isEnabled, message = '', allowedRoutes = ['/api/health', '/api/auth/login'], supportEmail = 'support@wdtp.io') => {
    try {
      const response = await authServiceRequest('/settings/maintenance', {
        method: 'PUT',
        data: { isEnabled, message, allowedRoutes, supportEmail }
      });
      return response;
    } catch (error) {
      console.error('Failed to toggle maintenance mode:', error);
      throw error;
    }
  },

  // Enable maintenance mode with message
  enableMaintenanceMode: async (message = 'System down for updates', allowedRoutes = ['/api/health', '/api/auth/login'], supportEmail = 'support@wdtp.io') => {
    try {
      const response = await authServiceRequest('/settings/maintenance', {
        method: 'PUT',
        data: { isEnabled: true, message, allowedRoutes, supportEmail }
      });
      return response;
    } catch (error) {
      console.error('Failed to enable maintenance mode:', error);
      throw error;
    }
  },

  // Disable maintenance mode
  disableMaintenanceMode: async () => {
    try {
      const response = await authServiceRequest('/settings/maintenance', {
        method: 'PUT',
        data: { isEnabled: false, message: '', allowedRoutes: [] }
      });
      return response;
    } catch (error) {
      console.error('Failed to disable maintenance mode:', error);
      throw error;
    }
  },

  // ============ USER ID PREFIX ENDPOINTS ============

  // Get current userIdPrefix (account ID prefix)
  getUserIdPrefix: async () => {
    try {
      const response = await authServiceRequest('/settings/user-id-prefix');
      return response;
    } catch (error) {
      console.error('Failed to get userIdPrefix:', error);
      throw error;
    }
  },

  // Update userIdPrefix (account ID prefix)
  updateUserIdPrefix: async (userIdPrefix) => {
    try {
      const response = await authServiceRequest('/settings/user-id-prefix', {
        method: 'PUT',
        data: { userIdPrefix }
      });
      return response;
    } catch (error) {
      console.error('Failed to update userIdPrefix:', error);
      throw error;
    }
  }
};

export default adminSettingsAPI; 